<template>

  <!-- Page Footer Social -->
  <div
    class="page-footer-social flex q-gutter-xs">

    <a
      rel="nofollow"
      target="_blank"
      href="https://vk.com/tendermosru">

      <q-btn
        round
        size="md"
        unelevated
        color="black">

        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="currentColor">

          <use
            xlink:href="/images/icons/icon-symbols.svg?v1#social-vk"/>

        </svg>

      </q-btn>

    </a>

    <a
      rel="nofollow"
      target="_blank"
      href="https://ok.ru/group/64198733136121?st._aid=GroupTopicLayer_VisitProfile">

      <q-btn
        round
        size="md"
        unelevated
        color="black">

        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="currentColor">

          <use
            xlink:href="/images/icons/icon-symbols.svg?v1#social-ok"/>

        </svg>

      </q-btn>

    </a>

    <a
      rel="nofollow"
      target="_blank"
      href="https://t.me/competitionis">

      <q-btn
        round
        size="md"
        unelevated
        color="black">

        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="currentColor">

          <use
            xlink:href="/images/icons/icon-symbols.svg?v1#social-tg"/>

        </svg>

      </q-btn>

    </a>

  </div>

</template>

<script>

  export default {
    name: 'page-footer-social',
    props: {},
  };

</script>

<style lang="scss">

  .page-footer-social {
    color: inherit;
  }

</style>
